import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import { guardString } from "@msuite/utils/strings";
import type { Nullable } from "@msuite/utils/types";
import { client } from "@/hono";

export function useSuborder(orderId: Nullable<string>, suborderId: Nullable<string>) {
	/** Query */
	const query = useQuery({
		queryKey: ["suborder", guardString(orderId), guardString(suborderId)],
		queryFn: async () => {
			const response = await client.stock.orders[":orderId"].suborders[":suborderId"].$get({
				param: {
					orderId: guardString(orderId),
					suborderId: guardString(suborderId),
				},
			});
			// Suppressed for the same reason as `useOrder`: the page renders the refusal itself.
			const data = await responseHandler(response, false);
			return data.suborder;
		},
		enabled: !!orderId && !!suborderId,
	});

	/** Return */
	return { ...query, suborder: query.data };
}
